import { useState, useEffect, useCallback } from 'react'
import { API, API_ROUTER } from '../../../../../api'
import { MONTHS_LIST } from '../../../constants'

export const useFollowedTournaments = () => {
  const [games, setGames] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [tournamentList, setTournamentList] = useState()
  const [pageTournament, setPageTournament] = useState(1)
  const [defaultGame, setDefaultGame] = useState(null)
  const [defaultMonth, setDefaultMonth] = useState(null)

  const getTournament = useCallback(async () => {
    setIsLoading(true)
    let urlParams = {}

    if (defaultMonth?.id) {
      urlParams['month'] = defaultMonth?.id
    }

    if (defaultGame?.id) {
      urlParams['gameId'] = defaultGame?.id
    }

    try {
      const res = await API.request({
        ...API_ROUTER.follow.getfollowedTournaments,
        urlParams,
        pathKeys: {
          page: pageTournament,
          limit: 10,
        },
      })
      setTournamentList(res)
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }, [defaultMonth?.id, defaultGame?.id, pageTournament])

  const getGames = useCallback(async () => {
    setIsLoading(true)
    try {
      const res = await API.request({
        ...API_ROUTER.games.getGames,
      })
      const newOptions = res?.games?.map((el) => ({ id: el.id, value: el.title })) || []
      setGames(newOptions)
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }, [])

  const handleChangeTournaments = useCallback((event, value) => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    setPageTournament(value)
  }, [])

  const changeSelectGame = useCallback((val) => {
    const findEl = games?.find(el => el.id === val)
    if (findEl) {
      setDefaultGame(findEl)
    }
  }, [games])

  const changeSelectMonth = useCallback((val) => {
    const findEl = MONTHS_LIST?.find(el => el.id === val)
    if (findEl) {
      setDefaultMonth(findEl)
    }
  }, [])

  const clearFilters = useCallback(() => {
    setDefaultMonth(null)
    setDefaultGame(null)
  }, [])

  useEffect(() => {
    getTournament()
  }, [getTournament])

  useEffect(() => {
    getGames()
  }, [getGames])

  return {
    games,
    isLoading,
    tournamentList,
    pageTournament,
    defaultGame,
    defaultMonth,
    handleChangeTournaments,
    changeSelectGame,
    changeSelectMonth,
    clearFilters
  }
}
